import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { CreateInventoryFormData } from "../schema/CreateInventorySchema";
import { InventoryResponseSchema } from "../response/CreateInventoryResponse";

export const useCreateInventory = () => {
    return useMutation({
        mutationFn: async (formData: CreateInventoryFormData) => await privateApi.post(`/v4/inventory`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = InventoryResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid inventory data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create inventory', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid inventory data format");
            } else {
                console.error(`Failed to create inventory`, error);
                throw error;
            }
        }
    });
};
